import { useState, useEffect } from 'react';
import axios from 'axios';

const api = (url, opts = {}) => axios({ url, ...opts, headers: { ...opts.headers, Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function AdminFidelidade() {
  const [aba, setAba] = useState('clientes');
  const [clientes, setClientes] = useState([]);
  const [extrato, setExtrato] = useState([]);
  const [recompensas, setRecompensas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const [toast, setToast] = useState('');
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [modalPontos, setModalPontos] = useState(null); // { cliente, tipo: 'add'|'remove' }
  const [qtdPontos, setQtdPontos] = useState('');
  const [motivoPontos, setMotivoPontos] = useState('');

  // Recompensas
  const [editandoRecomp, setEditandoRecomp] = useState(null);
  const [novaRecomp, setNovaRecomp] = useState(false);
  const [formRecomp, setFormRecomp] = useState({ nome: '', descricao: '', tipo: 'desconto_pct', valor: '', custo_pontos: '', ativo: true });

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const carregarClientes = async () => {
    setLoading(true);
    try {
      const r = await api('/api/relatorios/clientes');
      setClientes(r.data);
    } catch { showToast('❌ Erro ao carregar clientes'); }
    finally { setLoading(false); }
  };

  const carregarExtrato = async (usuarioId) => {
    try {
      const r = await api(`/api/fidelidade/extrato-admin/${usuarioId}`);
      setExtrato(r.data);
    } catch {}
  };

  const carregarRecompensas = async () => {
    try {
      const r = await api('/api/fidelidade/recompensas');
      setRecompensas(r.data);
    } catch {}
  };

  useEffect(() => {
    carregarClientes();
    carregarRecompensas();
  }, []);

  const ajustarPontos = async () => {
    if (!qtdPontos || !modalPontos) return;
    try {
      await api('/api/fidelidade/ajustar-pontos', {
        method: 'POST',
        data: {
          usuario_id: modalPontos.cliente.id,
          quantidade: parseInt(qtdPontos),
          tipo: modalPontos.tipo === 'add' ? 'bonus' : 'resgate',
          descricao: motivoPontos || (modalPontos.tipo === 'add' ? 'Bônus manual pelo admin' : 'Remoção manual pelo admin')
        }
      });
      showToast(modalPontos.tipo === 'add' ? `✅ +${qtdPontos} pontos adicionados!` : `✅ -${qtdPontos} pontos removidos!`);
      setModalPontos(null); setQtdPontos(''); setMotivoPontos('');
      carregarClientes();
      if (clienteSelecionado?.id === modalPontos.cliente.id) carregarExtrato(modalPontos.cliente.id);
    } catch (e) { showToast('❌ ' + (e.response?.data?.error || 'Erro')); }
  };

  const salvarRecompensa = async () => {
    if (!formRecomp.nome || !formRecomp.custo_pontos) return showToast('⚠️ Nome e custo obrigatórios');
    try {
      if (editandoRecomp) {
        await api(`/api/fidelidade/recompensas/${editandoRecomp}`, { method: 'PUT', data: formRecomp });
        showToast('✅ Recompensa atualizada!');
      } else {
        await api('/api/fidelidade/recompensas', { method: 'POST', data: formRecomp });
        showToast('✅ Recompensa criada!');
      }
      setEditandoRecomp(null); setNovaRecomp(false);
      setFormRecomp({ nome: '', descricao: '', tipo: 'desconto_pct', valor: '', custo_pontos: '', ativo: true });
      carregarRecompensas();
    } catch (e) { showToast('❌ ' + (e.response?.data?.error || 'Erro')); }
  };

  const toggleRecompensa = async (r) => {
    try {
      await api(`/api/fidelidade/recompensas/${r.id}`, { method: 'PUT', data: { ...r, ativo: !r.ativo } });
      carregarRecompensas();
    } catch {}
  };

  const clientesFiltrados = clientes.filter(c =>
    !busca || c.nome?.toLowerCase().includes(busca.toLowerCase()) || c.email?.toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <div style={{ padding: 24 }}>
      {toast && <div style={{ position: 'fixed', top: 70, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999, whiteSpace: 'nowrap' }}>{toast}</div>}

      <h2 style={{ marginBottom: 4 }}>⭐ Programa Fidelidade</h2>
      <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>Gerencie pontos, clientes e recompensas</p>

      {/* Abas */}
      <div style={{ display: 'flex', gap: 4, background: 'var(--bg3)', padding: 4, borderRadius: 8, marginBottom: 20 }}>
        {[['clientes','👥 Clientes'],['recompensas','🎁 Recompensas']].map(([key, label]) => (
          <button key={key} onClick={() => setAba(key)} style={{
            flex: 1, background: aba === key ? 'linear-gradient(90deg,var(--red),var(--orange))' : 'none',
            border: 'none', color: aba === key ? '#fff' : 'var(--text2)',
            padding: 9, borderRadius: 6, cursor: 'pointer',
            fontFamily: 'Nunito,sans-serif', fontWeight: 700, fontSize: 13
          }}>{label}</button>
        ))}
      </div>

      {/* ===== CLIENTES ===== */}
      {aba === 'clientes' && (
        <>
          <input className="input-field" placeholder="🔍 Buscar cliente..." value={busca}
            onChange={e => setBusca(e.target.value)} style={{ marginBottom: 16 }} />

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 10, marginBottom: 20 }}>
            {[
              ['👥', 'Total clientes', clientes.length, 'var(--orange)'],
              ['⭐', 'Total pontos', clientes.reduce((a, c) => a + (c.pontos || 0), 0).toLocaleString(), '#4a9eff'],
              ['💰', 'Total faturado', `R$ ${clientes.reduce((a, c) => a + parseFloat(c.total_gasto || 0), 0).toFixed(0)}`, '#2ea82e'],
            ].map(([icon, label, val, cor]) => (
              <div key={label} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 14, textAlign: 'center' }}>
                <div style={{ fontSize: 22 }}>{icon}</div>
                <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, color: cor, lineHeight: 1 }}>{val}</div>
                <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>{label}</div>
              </div>
            ))}
          </div>

          {loading ? <div className="spinner" /> : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 12 }}>
              {clientesFiltrados.map((c, i) => (
                <div key={c.id} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
                  <div style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'linear-gradient(135deg,var(--red),var(--orange))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 16, color: '#fff', flexShrink: 0 }}>
                      {i < 3 ? ['🥇','🥈','🥉'][i] : c.nome?.[0]?.toUpperCase()}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: 14 }}>{c.nome}</div>
                      <div style={{ fontSize: 11, color: 'var(--text2)' }}>{c.email}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--orange)' }}>⭐ {(c.pontos || 0).toLocaleString()}</div>
                      <div style={{ fontSize: 11, color: 'var(--text2)' }}>{c.qtd_pedidos || 0} pedidos</div>
                    </div>
                  </div>

                  <div style={{ padding: '0 16px 12px', display: 'flex', gap: 6 }}>
                    <button onClick={() => { setModalPontos({ cliente: c, tipo: 'add' }); }} style={{ flex: 1, background: 'rgba(46,168,46,.15)', border: '1px solid rgba(46,168,46,.3)', color: '#2ea82e', padding: '7px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>
                      ➕ Adicionar pontos
                    </button>
                    <button onClick={() => { setModalPontos({ cliente: c, tipo: 'remove' }); }} style={{ flex: 1, background: 'rgba(230,48,48,.1)', border: '1px solid rgba(230,48,48,.3)', color: 'var(--red)', padding: '7px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>
                      ➖ Remover pontos
                    </button>
                    <button onClick={() => { setClienteSelecionado(c); carregarExtrato(c.id); }} style={{ background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text2)', padding: '7px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>
                      📋
                    </button>
                  </div>

                  {/* Extrato inline */}
                  {clienteSelecionado?.id === c.id && (
                    <div style={{ borderTop: '1px solid var(--border)', padding: '12px 16px', background: 'var(--bg3)', maxHeight: 200, overflowY: 'auto' }}>
                      <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--text2)', marginBottom: 8, textTransform: 'uppercase' }}>Extrato de pontos</div>
                      {extrato.length === 0 ? <div style={{ fontSize: 12, color: 'var(--text3)' }}>Sem transações</div> : extrato.map((t, j) => (
                        <div key={j} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid var(--border)' }}>
                          <div>
                            <div style={{ fontWeight: 600 }}>{t.descricao}</div>
                            <div style={{ fontSize: 10, color: 'var(--text3)' }}>{new Date(t.criado_em).toLocaleDateString('pt-BR')}</div>
                          </div>
                          <span style={{ fontWeight: 800, color: t.quantidade > 0 ? '#2ea82e' : 'var(--red)' }}>
                            {t.quantidade > 0 ? '+' : ''}{t.quantidade} pts
                          </span>
                        </div>
                      ))}
                      <button onClick={() => setClienteSelecionado(null)} style={{ width: '100%', background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 11, marginTop: 8, fontFamily: 'Nunito,sans-serif' }}>Fechar ✕</button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* ===== RECOMPENSAS ===== */}
      {aba === 'recompensas' && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0 }}>Recompensas disponíveis</h3>
            <button onClick={() => { setNovaRecomp(true); setEditandoRecomp(null); setFormRecomp({ nome: '', descricao: '', tipo: 'desconto_pct', valor: '', custo_pontos: '', ativo: true }); }} style={{ background: 'linear-gradient(90deg,var(--red),var(--orange))', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontFamily: 'Nunito,sans-serif', fontWeight: 800 }}>+ Nova</button>
          </div>

          {(novaRecomp || editandoRecomp) && (
            <div className="card" style={{ marginBottom: 16, border: '1px solid var(--orange)' }}>
              <h3 style={{ color: 'var(--orange)', marginBottom: 14 }}>{editandoRecomp ? '✏️ Editar recompensa' : '➕ Nova recompensa'}</h3>
              <div className="input-group"><label className="input-label">Nome *</label><input className="input-field" placeholder="Ex: Batata frita grátis" value={formRecomp.nome} onChange={e => setFormRecomp(p => ({ ...p, nome: e.target.value }))} /></div>
              <div className="input-group"><label className="input-label">Descrição</label><input className="input-field" placeholder="Descrição da recompensa" value={formRecomp.descricao} onChange={e => setFormRecomp(p => ({ ...p, descricao: e.target.value }))} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="input-label">Tipo</label>
                  <select className="input-field" value={formRecomp.tipo} onChange={e => setFormRecomp(p => ({ ...p, tipo: e.target.value }))} style={{ cursor: 'pointer' }}>
                    <option value="desconto_pct">% Desconto</option>
                    <option value="desconto_valor">R$ Desconto</option>
                    <option value="produto_gratis">Produto grátis</option>
                  </select>
                </div>
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="input-label">Valor</label>
                  <input className="input-field" type="number" placeholder="0" value={formRecomp.valor} onChange={e => setFormRecomp(p => ({ ...p, valor: e.target.value }))} />
                </div>
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="input-label">Custo (pts) *</label>
                  <input className="input-field" type="number" placeholder="200" value={formRecomp.custo_pontos} onChange={e => setFormRecomp(p => ({ ...p, custo_pontos: e.target.value }))} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
                <button className="btn-primary" onClick={salvarRecompensa} style={{ flex: 1 }}>💾 Salvar</button>
                <button className="btn-secondary" style={{ width: 'auto', padding: '12px 16px' }} onClick={() => { setNovaRecomp(false); setEditandoRecomp(null); }}>Cancelar</button>
              </div>
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
            {recompensas.map(r => (
              <div key={r.id} style={{ background: 'var(--bg2)', border: `1px solid ${r.ativo ? 'var(--orange)' : 'var(--border)'}`, borderRadius: 12, padding: 16, opacity: r.ativo ? 1 : 0.6 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 14 }}>{r.nome}</div>
                    <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>{r.descricao}</div>
                  </div>
                  <label style={{ position: 'relative', width: 40, height: 22, cursor: 'pointer', flexShrink: 0 }}>
                    <input type="checkbox" checked={!!r.ativo} onChange={() => toggleRecompensa(r)} style={{ opacity: 0, width: 0, height: 0 }} />
                    <span style={{ position: 'absolute', inset: 0, background: r.ativo ? 'var(--orange)' : 'var(--bg4)', border: `1px solid ${r.ativo ? 'var(--orange)' : 'var(--border)'}`, borderRadius: 11, transition: '.2s' }}>
                      <span style={{ position: 'absolute', width: 16, height: 16, background: '#fff', borderRadius: '50%', top: 2, left: r.ativo ? 20 : 2, transition: '.2s' }} />
                    </span>
                  </label>
                </div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                  <span style={{ background: 'var(--bg4)', border: '1px solid var(--border)', padding: '3px 8px', borderRadius: 6, fontSize: 11, color: 'var(--orange)', fontWeight: 700 }}>⭐ {r.custo_pontos} pts</span>
                  {r.valor > 0 && <span style={{ background: 'var(--bg4)', border: '1px solid var(--border)', padding: '3px 8px', borderRadius: 6, fontSize: 11, color: '#2ea82e', fontWeight: 700 }}>{r.tipo === 'desconto_pct' ? `${r.valor}% OFF` : `R$ ${r.valor}`}</span>}
                </div>
                <button onClick={() => { setEditandoRecomp(r.id); setNovaRecomp(false); setFormRecomp({ nome: r.nome, descricao: r.descricao || '', tipo: r.tipo, valor: r.valor || '', custo_pontos: r.custo_pontos, ativo: !!r.ativo }); }} style={{ width: '100%', background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>✏️ Editar</button>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Modal ajuste de pontos */}
      {modalPontos && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.8)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: 'var(--bg2)', border: `2px solid ${modalPontos.tipo === 'add' ? '#2ea82e' : 'var(--red)'}`, borderRadius: 14, padding: 24, width: '100%', maxWidth: 380 }}>
            <h3 style={{ marginBottom: 4, color: modalPontos.tipo === 'add' ? '#2ea82e' : 'var(--red)' }}>
              {modalPontos.tipo === 'add' ? '➕ Adicionar pontos' : '➖ Remover pontos'}
            </h3>
            <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16 }}>Cliente: <strong>{modalPontos.cliente.nome}</strong> — {modalPontos.cliente.pontos || 0} pts atuais</p>
            <div className="input-group">
              <label className="input-label">Quantidade de pontos *</label>
              <input className="input-field" type="number" placeholder="Ex: 100" value={qtdPontos} onChange={e => setQtdPontos(e.target.value)} autoFocus />
            </div>
            <div className="input-group" style={{ marginBottom: 16 }}>
              <label className="input-label">Motivo</label>
              <input className="input-field" placeholder="Ex: Brinde especial, correção..." value={motivoPontos} onChange={e => setMotivoPontos(e.target.value)} />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn-primary" onClick={ajustarPontos} style={{ flex: 1, background: modalPontos.tipo === 'add' ? 'linear-gradient(90deg,#1a7a1a,#2ea82e)' : 'linear-gradient(90deg,#7a1a1a,var(--red))' }}>
                {modalPontos.tipo === 'add' ? '✅ Adicionar' : '✅ Remover'}
              </button>
              <button className="btn-secondary" style={{ width: 'auto', padding: '12px 16px' }} onClick={() => { setModalPontos(null); setQtdPontos(''); setMotivoPontos(''); }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
